"use client";

import Section from "@/components/section";

export default function Legal() {
  return (
    <Section className="bg-background py-4">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl font-bold mb-8">Legal Notice</h1>
        
        <div className="space-y-8">
          <div>
            <p className="mb-4">
              <strong>Address</strong>:
            </p>
            <p>
              Savages Corp Limited<br />
              Room 2103, Futura Plaza<br />
              111 How Ming Street<br />
              999070 Hong Kong
            </p>
          </div>

          <div>
            <p>
              <strong>Incorporation Number:</strong> 2749556
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-4">Contact Options</h3>
            <p>
              <strong>E-Mail Address:</strong><br />
              <a href="mailto:info@savagescorp.com" className="text-primary hover:underline">
                info@savagescorp.com
              </a>
            </p>
            <p className="mt-2">
              <strong>Contact form:</strong><br />
              <a 
                href="https://calendly.com/savagescorp-cm/ai-consulting?month=2025-05" 
                target="_blank" 
                rel="noopener"
                className="text-primary hover:underline max-md:break-words"
              >
                https://calendly.com/savagescorp-cm/ai-consulting
              </a>
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-4">Liability and Intellectual Property Rights Information</h3>
            <div className="space-y-4">
              <p>
                <strong>Link Disclaimer:</strong> We do not accept any responsibility for or endorse the content of external websites we link to, whether directly or indirectly. The providers of the linked websites are solely responsible for all content presented on their websites and in particular, any damage resulting from the use the information offered on their websites.
              </p>
              <p>
                <strong>Copyrights and Trademarks:</strong> All contents presented on this website, such as texts, photographs, graphics, brands and trademarks are protected by the respective intellectual property rights (copyrights, trademark rights). The use, reproduction, etc. are subject to our rights or the rights of the respective authors or rights owners.
              </p>
              <p>
                <strong>Information on legal infringements:</strong> Please notify us if you notice any rights violations on our website. Once notified, we will promptly remove any illegal content or links.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}
